<template>
 <div id="exchangeArrayDiv">
   <!-- {{levelExchangeArray}} -->
    <div v-for="(item,index) in divideExchangeArray" :key="index" :index="index+''">
      <MoneyOptionItem>
        <template #moOption>
          <div v-if="$store.state.openRebateUI1" :class="index == selectedIndex?'rebateUI1SelectedBg':'moOption'" @click="moneyClick(index, item['exchangeMoney'])">{{item['exchangeMoney']}}</div>
          <div v-else :class="index == selectedIndex?'selectedBg':'moOption'" @click="moneyClick(index, item['exchangeMoney'])">{{item['exchangeMoney']}}</div>
        </template>
        
        <template v-if="item['isFirst'] && $store.state.openRebateUI1" #moRebateUI1FirstSimbol>
          <div id="moRebateUI1FirstSimbol">
            <label id="molabel">首次兑换</label>
          </div>
        </template>
        <template v-else-if="item['isFirst']&& !$store.state.openRebateUI1" #moFirstSimbol>
          <div id="moFirstSimbol">
            <label id="molabel">首次兑换</label>
          </div>
        </template>
      </MoneyOptionItem>
    </div>
 </div>
</template>

<script>
import MoneyOptionItem from "views/RebateView/CashOut/MoneyOptionItem.vue"
 export default {
   data () {
     return {
        divideExchangeArray: this.$store.getters.getDivideExchangeList,
        selectedIndex: -1,
     }
   },
   components: {
    MoneyOptionItem,
   },
   methods:{
    moneyClick(index, selectedExchangeMoney){
      this.selectedIndex = index;
      this.$emit("selectedExchangeMoney", selectedExchangeMoney);
    }
   }
 }
</script>

<style>
  /* 兑换金额选项的父级div */
  #exchangeArrayDiv{
    float: left;
    /* display: flex; */
    display: -webkit-box;
    display: -ms-flexbox;
    margin-left: 5px;
    width: 280px;
    height: 55px;
    flex-direction: row;
    justify-content: center; /*水平居中*/
    align-items: Center; /*垂直居中*/
    /* background-color: aquamarine; */
    overflow-x:auto;
    /* 下面的操作都是为了隐藏滑条 */
    scrollbar-width: none;
    -ms-overflow-style: none;
    /* overflow: hidden; */
  }
  #exchangeArrayDiv::-webkit-scrollbar{
    display: none;
  }
 
</style>


// WEBPACK FOOTER //
// src/views/RebateView/CashOut/DivideExchangeOptions.vue